import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { Notification } from '../types/notification.types';

/**
 * REST du centre de notifications (notification-service via gateway
 * `/notification/api/notifications`). Sert l'état initial + les actions.
 * Le temps réel passe par {@link NotificationSocketService} (STOMP).
 */
@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/notification/api/notifications`;

  /** Liste paginée des notifs du user courant (enveloppe Nawam). */
  list(query: PageQuery = {}): Observable<ApiPageResponse<Notification>> {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 20))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return this.http.get<ApiPageResponse<Notification>>(this.base, { params });
  }

  /** Compteur de non-lus du user — sert à bootstrapper le badge à l'init. */
  countUnread(): Observable<number> {
    return this.http.get<number>(`${this.base}/count/unread`);
  }

  /** Marque une notif lue. */
  markRead(id: number): Observable<Notification> {
    return this.http.patch<Notification>(`${this.base}/${id}/read`, {});
  }

  /** Marque toutes les notifs du user lues. Retour `{message, count}`. */
  markAllRead(): Observable<{ message: string; count: number }> {
    return this.http.patch<{ message: string; count: number }>(
      `${this.base}/read-all`,
      {},
    );
  }

  /** Supprime une notif. */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
